import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  courses: null,
  quizzesByCourse: {},
  configurations: null,
  selectedInstanceId: null,
  categories: null,
};

/**
 * @memberOf module:MoodleCourse
 * @namespace store
 * @description central store for moodle course module
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
